// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles-m__breadcrumbs__2fkPh","breadcrumb":"styles-m__breadcrumb__2mCVQ"};